<!-- Content -->
@if (form) {
  <medsurf-design-form-control-form
    [formGroup]="form"
    [class]="'w-full'"
    (onSubmit)="onSubmit()">
    <div medsurf-design-content-input-group>
      <!-- Solution -->
      <medsurf-design-input-radio-button [formField]="false"
        [name]="'single_choice_solution_' + choice.id"
        [model]="solution"
        [value]="index"
        (valueChange)="onChange()">
      </medsurf-design-input-radio-button>
      <!-- Editor -->
      <medsurf-editor [formField]="false"
        [control]="form.controls.label"
        placeholder="global.answer"
      (valueChange)="onSubmit()"></medsurf-editor>
      <!-- Delete -->
      @if (question.type === FlatModels.QuestionEntityModels.QuestionType.enum.LongListQuestion) {
        <button medsurf-design-input-button
          [id]="'single_choice_choice_remove_' + choice.id"
          [title]="'global.choice_remove' | translate"
          [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.DANGER_FUllHEIGHT"
          [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.REMOVE"
        (click)="removeChoice()"></button>
      }
    </div>
  </medsurf-design-form-control-form>
}
